import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import { Tooltip } from 'react-lightweight-tooltip'
import { getParticipantsString, getRecommendationsPath } from './util'
import { bindKeywordArguments } from './actions'
import { dateCellRenderer } from './components/Generic'
import get from 'lodash/get'
import last from 'lodash/last'
import concat from 'lodash/concat'


const recommendationsDateLinkRenderer = bindKeywordArguments(dateCellRenderer, {
  getTarget: bet => {
    if(!get(bet, 'ticket.delivery_date')) { return }
    return getRecommendationsPath(bet.player_id, moment(bet.ticket.delivery_date))
  }
});

const EventDetails = ({description, eventId, begin}) => (
  <Tooltip
    content={[
      <div key={eventId} className="event-tooltip">
        <h3>Event participants</h3>
        <ul>
          {description.split(' - ').map((p, i) => <li key={i}>{p}</li>)}
        </ul>
      </div>
    ]}>
    <div className="table-cell__value--ellipsis">{description}</div>
    <div className="table-cell__secondary-value">{moment(begin).utc().format('DD/MM/YYYY HH:mm')}</div>
  </Tooltip>
);

const EventMarkets = ({rowData}) => {
  return (
    <div>
      {rowData.markets.map(m => (
        <div key={m.name} className="hbox market-row">
          <div className='hbox--flex market-description'>{m.name} {m.children[0].name}</div>
          <div className="hbox">
            {m.children[0].children.map(m => <div className='choice-param' key={m.name}>{m.name}</div>)}
          </div>
        </div>
      ))}
    </div>
  )
};


export const betsColumns = [
  {
    label: 'ids',
    dataKey: 'id',
    cellRenderer: ({rowData}) => rowData.id && [
      <div key='1' className="betid"><span className="label">bet:</span> {rowData.id}</div>,
      <div key='2' className="betid"><span className="label">ticket:</span> {rowData.ticket_id}</div>
    ],
    className: 'small-table-column betids-column'
  }, {
    label: 'country',
    dataKey: 'event.country',
    sortable: true,
    className: 'small-table-column'
  }, {
    label: 'sport',
    dataKey: 'event.sport',
    sortable: true,
    className: 'small-table-column'
  }, {
    label: 'event',
    dataKey: 'event',
    cellRenderer: ({rowData}) => (
      <div>
        <div>{getParticipantsString(rowData.event)}</div>
        <div className="table-cell__secondary-value">id: {get(rowData, 'event_id')}</div>
      </div>
    ),
    className: 'medium-table-column'
  }, {
    label: 'result type',
    dataKey: 'market.type',
    sortable: true,
    className: 'generic-table-column',
    cellRenderer: ({rowData}) => (
      [get(rowData, 'market.market_type'), get(rowData, 'market.market')].join(' ')
    )
  }, {
    label: 'ticket date',
    dataKey: 'delivery_date',
    sortable: true,
    cellRenderer: recommendationsDateLinkRenderer,
    className: 'generic-table-column'
  }, {
    label: 'begin',
    dataKey: 'event.begin',
    sortable: true,
    cellRenderer: recommendationsDateLinkRenderer,
    className: 'generic-table-column'
  }, {
    label: 'odds',
    dataKey: 'quote',
    sortable: true,
    className: 'small-table-column'
}];

export const smallTableBetsColumns = concat(
  betsColumns.filter(col => 
    ['land', 'sport'].indexOf(col.label) !== -1
  ),
  [{
    label: 'event',
    dataKey: 'event',
    cellRenderer: ({rowData}) => (
      <EventDetails 
        description={getParticipantsString(get(rowData, 'event'))} 
        eventId={get(rowData, 'event_id')} />
    ),
    className: 'generic-table-column'
  }, {
    label: 'ticket date',
    dataKey: 'delivery_date',
    cellRenderer: ({rowData}) => (
      get(rowData, 'delivery_date') 
        ? moment(rowData.delivery_date).format('DD/MM/YYYY HH:mm')
        : ''
    ),
    className: 'generic-table-column'
  }, {
    label: 'bet begin time',
    dataKey: 'event.begin',
    cellRenderer: ({rowData}) => (
      get(rowData, 'event.begin') ? moment(get(rowData, 'event.begin')).utc().format('DD/MM/YYYY HH:mm') : ''
    ),
    className: 'generic-table-column'
  }
]);

export const recommendationsColumns = [
  {
    label: 'confidence',
    dataKey: 'confidence',
    cellRenderer: ({rowData}) => numeral(rowData.confidence).format('0.00000%'),
    className: 'generic-table-column'
  }, {
    label: 'event',
    dataKey: 'description',
    cellRenderer: ({rowData}) => (
      <EventDetails 
        description={getParticipantsString(rowData)} 
        eventId={get(rowData, 'event_id')} />
    ),
    className: 'generic-table-column'
  }, {
    label: 'country',
    dataKey: 'country',
    className: 'generic-table-column'
  }, {
    label: 'sport',
    dataKey: 'sport',
    className: 'generic-table-column'
  }, {
    label: 'bet begin time',
    dataKey: 'start_timestamp',
    cellRenderer: ({rowData}) => (
      rowData.start_timestamp ? moment(rowData.start_timestamp).format('DD/MM/YYYY HH:mm') : ''
    ),
    className: 'generic-table-column'
}];

export const couponColumns = [
  {
    label: 'event',
    dataKey: 'description',
    cellRenderer: ({rowData}) => (
      <EventDetails 
        description={getParticipantsString(rowData)} 
        eventId={get(rowData, 'event_id')}
        begin={get(rowData, 'begin')} />
    ),
    className: 'generic-table-column'
  }, {
    label: 'event categories',
    dataKey: 'country',
    className: 'generic-table-column',
    cellRenderer: ({rowData}) => (
      <div>
        <div className='table-cell-list-item'>{rowData.sport}</div>
        <div className='table-cell-list-item'>{rowData.country}</div>
        <div className='table-cell-list-item'>{last((rowData.tournament || '').split('@'))}</div>
      </div>
    )
  }, {
    label: 'markets',
    dataKey: 'markets',
    cellRenderer: EventMarkets,
    className: 'markets-table-column'
}];


// WEBPACK FOOTER //
// ./src/settings.js